import { ApiRoutes } from '../helpers/routes'
import { CommunityDTO } from '../models/community'
import { SimplePostDTO } from '../models/post'
import fetchApi from './fetchApi'

const baseUrl = `${process.env.REACT_APP_API_URL}/api/communities`

class CommunitiesService {
    getAllCommunities = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.getAll}`, {
            method: 'GET',
        })
    }

    getPublicCommunities = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.getPublic}`, {
            method: 'GET',
        })
    }

    getPrivateCommunities = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.getPrivate}`, {
            method: 'GET',
        })
    }

    getCommunityById = async (id: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.getById.replace(':id', id)}`, {
            method: 'GET',
        })
    }

    getCommunitiesByUser = async (userId: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.communities.getByUserId.replace(':userId', userId)}`,
            {
                method: 'GET',
            },
        )
    }

    getMyCommunities = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.getMine}`, {
            method: 'GET',
        })
    }

    getMyPendingRequests = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.getMyPendingRequests}`, {
            method: 'GET',
        })
    }

    createCommunity = async (body: CommunityDTO) => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.create}`, {
            method: 'POST',
            body: JSON.stringify(body),
        })
    }

    editCommunity = async (body: CommunityDTO) => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.edit.replace(':id', body.id)}`, {
            method: 'PUT',
            body: JSON.stringify(body),
        })
    }

    removeMember = async (userId: string, communityId: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.communities.removeMember.replace(':userId', userId).replace(':communityId', communityId)}`,
            {
                method: 'DELETE',
            },
        )
    }

    requestJoin = async (id: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.requestJoin.replace(':id', id)}`, {
            method: 'POST',
        })
    }

    removeRequest = async (id: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.requestJoin.replace(':id', id)}`, {
            method: 'DELETE',
        })
    }

    addMember = async (userId: string, communityId: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.communities.addMember.replace(':id', communityId)}`,
            {
                method: 'POST',
                body: JSON.stringify({ userId }),
            },
        )
    }

    rejectRequest = async (userId: string, communityId: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.communities.rejectRequest.replace(':userId', userId).replace(':communityId', communityId)}`,
            {
                method: 'DELETE',
            },
        )
    }

    getCommunityPosts = async (id: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.getPosts.replace(':id', id)}`, {
            method: 'GET',
        })
    }

    getPendingPosts = async (id: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.getPendingPosts.replace(':id', id)}`, {
            method: 'GET',
        })
    }

    createCommunityPost = async (id: string, post: SimplePostDTO) => {
        return fetchApi(`${baseUrl}${ApiRoutes.communities.createPost.replace(':id', id)}`, {
            method: 'POST',
            body: JSON.stringify(post),
        })
    }

    addAdmin = async (userId: string, communityId: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.communities.addAdmin.replace(':communityId', communityId)}`,
            {
                method: 'POST',
                body: JSON.stringify({ userId }),
            },
        )
    }

    removeAdmin = async (userId: string, communityId: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.communities.removeAdmin.replace(':userId', userId).replace(':communityId', communityId)}`,
            {
                method: 'DELETE',
            },
        )
    }

    approvePost = async (communityId: string, postId: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.communities.approvePost.replace(':communityId', communityId).replace(':postId', postId)}`,
            {
                method: 'PATCH',
            },
        )
    }

    rejectPost = async (communityId: string, postId: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.communities.rejectPost.replace(':communityId', communityId).replace(':postId', postId)}`,
            {
                method: 'PATCH',
            },
        )
    }
}

export default CommunitiesService
